import React from 'react';

const Section = ({ id, bgClass = 'bg-white', title, children, className = '', style = {} }) => (
  <section
    id={id}
    className={`${bgClass} text-navy py-12 ${className} overflow-x-hidden`}
    style={style}
  > 
    {title && (
      <h2 className="text-center text-2xl font-bold text-black mb-6">{title}</h2>
    )}
    <div className="px-4 sm:px-6 lg:px-8">{children}</div>
  </section>
);

export default Section;
